<template>
  <ExtraGuaranteeProductCard
    :title="`+ ${$t('Add protection')}`"
    :is-secondary-color="true"
    @click="handleExtraGuaranteeClick"
  />
</template>

<script lang="ts">

import {
  cartGetters,
} from '~/utils/ct';
import type { LineItem } from '~~/types/commercetools';

import { getTotalGrossPriceBeforeDiscount } from '~~/helpers/cart/getTotalPrices';

export default defineComponent({
  name: 'AddExtraGuarantee',

  props: {
    product: {
      type: Object as PropType<LineItem>,
      required: true,
    },
  },
  emits: ['clickRemove'],
  setup (props, { emit }) {

    const {
      addExtraGuaranteeProduct,
    } = useCartExtended();
    const { setIsGuaranteeActionBeingClicked } = useLineItems();
    const { toggleCartSidebar } = useCartSidebarStore();
    const { setExtraGuaranteeInfo } = useExtraGuarantee();
    const { toggleExtraGuarantee } = useUiState();
    const title = computed(() => cartGetters.getItemName(props.product));

    const handleExtraGuaranteeClick = () => {

      setExtraGuaranteeInfo({
        fullProductPrice: getTotalGrossPriceBeforeDiscount(props.product),
        name: props?.product?.name,
        image: props.product.variant?.images?.[0]?.url,
        sku: props.product.variant.sku,
      });

      emit('clickRemove');
      setIsGuaranteeActionBeingClicked(true);
      toggleCartSidebar();
      toggleExtraGuarantee();
    
    };

    return {
      addExtraGuaranteeProduct,
      title,
      handleExtraGuaranteeClick,
    };
  
  },
});


</script>
